import { render } from "./HomeWelcomeComposer.vue?vue&type=template&id=fe924bfe&scoped=true"
import script from "./HomeWelcomeComposer.vue?vue&type=script&lang=js"
export * from "./HomeWelcomeComposer.vue?vue&type=script&lang=js"

import "./HomeWelcomeComposer.vue?vue&type=style&index=0&id=fe924bfe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe924bfe"]])

export default __exports__